import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  mediasUrl: string;
  constructor() {
    if (window.location.origin !== 'http://localhost:4200') {
      this.mediasUrl = window.location.origin + window.location.pathname
      .replace('dist/edc-project/home', '')
      .replace('home', '') + 'src/assets';
    } else {
      this.mediasUrl = '/assets';
    }
  }
}
